import { ArrowCircleIcon } from './CustomIcons/ArrowCircle';
import { ArrowRightIcon } from './CustomIcons/ArrowRight';
import { ArrowTopRightIcon } from './CustomIcons/ArrowTopRight';
import { Chevron } from './CustomIcons/Chevron';
import { CircleCheck } from './CustomIcons/CircleCheck';
import { Cloudflare } from './CustomIcons/Cloudflare';
import { Facebook } from './CustomIcons/Facebook';
import { Github } from './CustomIcons/Github';
import { Hydrogen } from './CustomIcons/Hydrogen';
import { LightbulbIcon } from './CustomIcons/LightbulbIcon';
import { Link } from './CustomIcons/Link';
import { Linkedin } from './CustomIcons/Linkedin';
import { Netlify } from './CustomIcons/Netlify';
import { Next } from './CustomIcons/Next';
import { Node } from './CustomIcons/Node';
import { Nuxt } from './CustomIcons/Nuxt';
import { QuoteIcon } from './CustomIcons/QuoteIcon';
import { React } from './CustomIcons/React';
import { Sanity } from './CustomIcons/Sanity';
import { Shopify } from './CustomIcons/Shopify';
import { Star } from './CustomIcons/Star';
import { Storyblok } from './CustomIcons/Storyblok';
import { Strapi } from './CustomIcons/Strapi';
import { TikTok } from './CustomIcons/TikTok';
import { TwitterX } from './CustomIcons/TwitterX';
import { Vercel } from './CustomIcons/Vercel';
import { Vue } from './CustomIcons/Vue';
import { Web } from './CustomIcons/Web';

export const icons = {
  arrowCircle: ArrowCircleIcon,
  arrowRight: ArrowRightIcon,
  arrowTopRight: ArrowTopRightIcon,
  chevron: Chevron,
  circleCheck: CircleCheck,
  cloudflare: Cloudflare,
  facebook: Facebook,
  github: Github,
  lightbulb: LightbulbIcon,
  link: Link,
  linkedin: Linkedin,
  netlify: Netlify,
  next: Next,
  node: Node,
  nuxt: Nuxt,
  quote: QuoteIcon,
  react: React,
  sanity: Sanity,
  shopify: Shopify,
  star: Star,
  storyblok: Storyblok,
  strapi: Strapi,
  tiktok: TikTok,
  twitter: TwitterX,
  vercel: Vercel,
  vue: Vue,
  web: Web,
  hydrogen: Hydrogen,
};

export type Icon = keyof typeof icons;
